import { useEffect, useRef, useState } from "react";

export function useSmartVideoPoster(src: string) {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  const [poster, setPoster] = useState<string>("");

  // ---- 1. Lazy Loading ----
  useEffect(() => {
    if (!videoRef.current) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(videoRef.current!);
        }
      },
      { threshold: 0.2 }
    );

    observer.observe(videoRef.current);

    return () => observer.disconnect();
  }, []);

  return { videoRef, isVisible, poster };
}
